import React from 'react';
import { Skeleton } from 'antd';

// Match Waiting-price reports throughout settings, including nested editors.
export default function SettingsLoading({ spinning = true, children }) {
  return spinning ? <div role="status" aria-label="Loading settings"><Skeleton active paragraph={{ rows: 7 }} /></div> : children;
}
